<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="$l('dialog_title_mixedSku') || '混装方案设置'"
      visible
      direction="rtl"
      :size="1100"
      @close="() => (backDialogVisible = true)"
      append-to-body
    >
      <div class="drawer-main">
        <Main ref="main" @close="close" :platformCode="platformCode" />
      </div>
      <div class="drawer-footer">
        <el-button type="primary" size="small" @click="confirm()">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </div>
    </el-drawer>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="confirm()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    platformCode: { type: String, default: '' },
  },
  data() {
    return { backDialogVisible: false }
  },
  methods: {
    close() {
      this.backDialogVisible = false
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    async confirm() {
      const result = await this.$refs.main.validate()
      if (!result) return (this.backDialogVisible = false)

      const data = this.$refs.main.getData()
      this.$emit('confirm', data)
      this.close()
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 10px;
}
.drawer-footer {
  padding: 10px 20px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
